import { asSingleStyleConfig } from '../../utils/theme';
var baseStyle = {
  w: '100%',
  mx: 'auto',
  maxW: 'container.xl',
  px: {
    base: '1.25rem',
    mdlg: '1.5rem',
    lg: '1rem'
  }
};
export default asSingleStyleConfig({
  baseStyle
});